/* eslint-disable import/prefer-default-export */
import { client } from 'lib/evi-api-gateway';

const url = `${process.env.REACT_APP_API_URL_USER}/auth`;
const apiurl = `${process.env.REACT_APP_API_URL}`;

export async function login(params) {
  return client.post({
    url: `${url}/login`,
    form: {
      ...params,
    },
  });
}
// getProfile
export async function getUserProfile(params) {
  return client.post({
    url: `${apiurl}/admin/user/me`,
    form: {
      access_token: params,
    },
  });
}
// loginOut
export async function logout(params) {
  return client.post({
    url: `${url}/logout`,
    form: {
      ...params,
    },
  });
}

// 获取该学校分校信息
export async function getMerchant(params) {
  return client.post({
    url: `${apiurl}/admin/merchant/me`,
    form: {
      ...params,
    },
  });
}
